// src/api.js
import axios from 'axios';

// Create an Axios instance with a base URL that respects the HTTPS setting
const useHttps = process.env.HTTPS === 'true';
const backendUrl = process.env.REACT_APP_RXROOSTER_BACKEND_URL || 'http://localhost:3001';

// Convert http to https if HTTPS is enabled
const secureBackendUrl = useHttps && backendUrl.startsWith('http:') 
  ? backendUrl.replace('http:', 'https:') 
  : backendUrl;

console.log('API connecting to:', secureBackendUrl, 'HTTPS enabled:', useHttps);

const api = axios.create({
  baseURL: secureBackendUrl,
});

// Add a request interceptor to attach the JWT token
api.interceptors.request.use(
  (config) => {
    // Retrieve the token from localStorage.
    const token = localStorage.getItem('authToken');
    if (token) {
      // Attach the token to the Authorization header.
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
